import { render, staticRenderFns } from "./tireDialog.vue?vue&type=template&id=9bcaeafa&"
import script from "./tireDialog.vue?vue&type=script&lang=ts&"
export * from "./tireDialog.vue?vue&type=script&lang=ts&"
import style0 from "./tireDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports